import React, { useEffect, useState } from "react";

import { api, type ReceiptSummaryData } from "../lib/api";
import { logError } from "../lib/errors";

function formatCurrencyAmount(amount: string) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return amount;
  return `¥${n.toLocaleString("ja-JP")}`;
}

export function getCurrentMonthDateRange(now: Date = new Date()) {
  const pad = (n: number) => String(n).padStart(2, "0");
  const year = now.getFullYear();
  const month = now.getMonth();
  const dateFrom = `${year}-${pad(month + 1)}-01`;
  const lastDay = new Date(year, month + 1, 0).getDate();
  const dateTo = `${year}-${pad(month + 1)}-${pad(lastDay)}`;
  return { dateFrom, dateTo };
}

export function ReceiptMonthlySummaryCard() {
  const [summary, setSummary] = useState<ReceiptSummaryData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const { dateFrom, dateTo } = getCurrentMonthDateRange();
        const result = await api.getReceiptSummary({ dateFrom, dateTo });
        if (!cancelled) setSummary(result);
      } catch (error) {
        logError(error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || !summary) return null;

  return (
    <section
      aria-label="今月の領収書サマリー"
      className="mb-5 rounded-[2rem] border border-[#EADBC8] bg-white/80 p-4 shadow-[0_18px_48px_rgba(124,90,78,0.12)] sm:p-5"
    >
      <p className="text-[11px] font-black uppercase tracking-[0.14em] text-[#A67C52]">今月のまとめ</p>
      <div className="mt-3 grid grid-cols-3 gap-3">
        <div>
          <p className="text-[11px] font-bold text-[#9C867D]">合計金額</p>
          <p className="mt-1 text-lg font-black text-[#5D4D46]">{formatCurrencyAmount(summary.totalAmount)}</p>
        </div>
        <div>
          <p className="text-[11px] font-bold text-[#9C867D]">件数</p>
          <p className="mt-1 text-lg font-black text-[#5D4D46]">{summary.count}件</p>
        </div>
        <div>
          <p className="text-[11px] font-bold text-[#9C867D]">未精算</p>
          <p className="mt-1 text-lg font-black text-[#B07030]">{summary.unsettledCount}件</p>
        </div>
      </div>
    </section>
  );
}
